const tryFunction = fn => {
  try {
    return fn();
  } catch (error) {
    return null;
  }
};

export default tryFunction;
